import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Page from "components/Page";
import {
  CardHeader,
  Card,
  CardBody,
  CardText,
  Button,
  Table,
  Row,
  Col,
  Alert
} from "reactstrap";
import "../../styles/estilos.css";
import Pagination from "react-js-pagination";
import { Textbox, Select as Select1 } from "react-inputs-validation";
import Select from 'react-select';
import { FetchGuardarDatosConducto, FetchGuardarFormaPago,FetchObtenerConductos } from "../../redux/actions/aCotizacion";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {urlGetPlanesPago, urlFVinculacion} from "../../constants/urls"
import { FetchPost } from '../../redux/actions/api'
import { setObtenerDatosDebitoAutomatico } from "../../redux/actions/aCotizacion";

 
class DebitoAutomatico extends React.Component {
  constructor(props) {
    super(props);
    const { datosListadoConductos } = this.props;

    this.state = {
        valSubmit: false,
        esTarjeta: false,
        validate: false,
        crearConducto: false,
        selectConducto: false,
        selectTipo:'',
        selectBanco:'',
        selectPlan:'',
        textCuenta:'',
        textFecha:'',
        textCodigo:'',
        datosConductoSel:'',
        codCoreTipo:'',
        nombreTipo:'',
        valCuotaCal: '0.00',
        hasTipoError: true,
        hasFechaError: true,
        //hasCodigoError: true,
        hasCuentaError: true,
        hasBancoError: true,
        hasPlanError: true,
        hasValorCuotaError: false,
        hasNumCuotaError: false,
        activePage: 1,
        datosListadoConductos,
        numCuotasF:'',
        valorCuotaMinimaF:'',
        numeroElementos:datosListadoConductos.listaConductos.length,
        loadingvalue:false ,
        mostrarPlanesPago:false      
    };
    this.validateForm = this.validateForm.bind(this);
  }
    handlePageChange = (pageNumber)=> {
    //console.log(`active page is ${pageNumber}`);
    this.setState({activePage: pageNumber});
  }
  toggleValidating(validate) {
    this.setState({ validate });
  }

  async validateForm(e) {
    e.preventDefault();
    this.setState({loadingvalue:true});   
    this.toggleValidating(true);
    this.valSubmit();
    const {
        selectTipo,
        selectBanco,
        selectPlan,
        textCuenta,
        textFecha,
        codCoreTipo,
        nombreTipo,
        hasTipoError,
        hasBancoError,
        hasPlanError,
        hasFechaError,
        //hasCodigoError,
        hasCuentaError,
        esTarjeta,
        selectConducto
    } = this.state;

    let validaCampos = false;
    let valorCuotaMinima = 0;
    let numCuotas = 0;
    let valorCuota = this.state.valCuotaCal;
    let cuotaPlan = selectPlan.cuotas;
    let idConducto='';
    if(selectConducto){
        if (!hasPlanError){            
            validaCampos=true;   
            numCuotas=this.state.datosConductoSel.numeroCuotasMaximo;
            valorCuotaMinima=this.state.datosConductoSel.valorCuotaMinima;
            idConducto=this.state.datosConductoSel.id;   
        }      
    }else{
        if (!hasTipoError && !hasBancoError && !hasPlanError && !hasCuentaError) {
            if(esTarjeta){
                if (!hasFechaError){
                    validaCampos=true;     
                    numCuotas=this.state.selectBanco.mesesT;
                    valorCuotaMinima=this.props.datosDebito.debitoAuomatico.valorCuotaMinimaTarjeta;
                }
            }else{
                validaCampos=true;     
                numCuotas=this.state.selectBanco.mesesC;
                valorCuotaMinima=this.props.datosDebito.debitoAuomatico.valorCuotaMinimaCuenta;  
            }
        }
    }    
    //console.log(this.props);
    if(validaCampos){
        if(numCuotas>=cuotaPlan){
            this.valNumCuota(false);
            if(valorCuota >= valorCuotaMinima){
                this.valValorCuota(false);
                //console.log("Valido!");
                if(!selectConducto){
                    const datosJSON = {
                        empresa: "AIGMETROPOLITANA",
                        plataforma: "WEB",
                        numeroCuentaOTarjeta: textCuenta,
                        codigoBanco: selectBanco.value,
                        tipoCuentaoTarjeta: selectTipo,
                        tipoCuentaoTarjetaCodigoCore: codCoreTipo,
                        tipoCuentaoTarjetaNombre: nombreTipo,
                        idCliente: this.props.dataFacturacion.datosFacturacion.datosPagador[0].id,//this.props.datosCarrito.productosCarrito.carDatosPagadorFacturacion[0].id,
                        anioVencimientoTarjeta: textFecha,
                        numeroCuotasMaximo: numCuotas,
                        valorCuotaMinima: valorCuotaMinima
                    }
                    //console.log("CONDUCTOS ENVIARRRR DATOS ", JSON.stringify(datosJSON))
                    await this.props.guardarConducto(datosJSON);
                    if (!this.props.datosGuardarConducto.guardarConductoHasError) {
                        idConducto = this.props.datosGuardarConducto.datoConducto;
                        //console.log(idConducto);
                        //refrescar el listado de conductos
                        await this.props.listarConductos({
                            "empresa":"AIGMETROPOLITANA",
                            "plataforma":"WEB",
                            "idCliente": this.props.dataFacturacion.datosFacturacion.datosPagador[0].id//this.props.datosCarrito.productosCarrito.carDatosPagadorFacturacion[0].id
                      
                          })
                          this.setState({
                            crearConducto: false,
                        })   
                    }
                }
                const PagoJSON = {
                    empresa: "AIGMETROPOLITANA",
                    plataforma: "WEB",
                    idCarrito: this.props.dataFacturacion.datosFacturacion.idCarrito,//this.props.datosCarrito.productosCarrito.idCarrito,
                    formCodigo: "debito-automatico",
                    idConducto: idConducto,
                    idPlanPago: selectPlan.value
                }

                await this.props.guardarFormaPago(PagoJSON);        
                if (!this.props.datosGuardarFormaPago.guardarFormaPagoHasError) {
                    //console.log('PAGO CORRECTO');
                    //window.location.reload(); 

                    /**** Agregar codigo para solicitar formulario de vinculacionde  libelula  */
                    let resp = await FetchPost({
                        url: urlFVinculacion+this.props.dataFacturacion.datosFacturacion.idCarrito,
                        param:''
                      });
                      const { transaccion, pasarPantallaFormulario, urlFormulario } = resp;  
                      if (transaccion) {
        
                        if(pasarPantallaFormulario)
                        {
                          this.props.history.push({
                            pathname: "/formulario-vinculacion",
                            search: `?url=${urlFormulario}&id=${this.props.dataFacturacion.datosFacturacion.idCarrito}`,
                            });
                        }
                    }
                    else{
                        /** COdigo para redireccionar correctamente */
                        this.props.history.push({
                            pathname: '/final-cotizacionbroker' 
                          });
                    }
                }
                //console.log(PagoJSON);
            
            }else{
                this.valValorCuota(true);
                this.valNumCuota(false);
            }
        }else{
            this.valNumCuota(true);
            this.valValorCuota(false);
        }
    }else{
        this.valNumCuota(false);
        this.valValorCuota(false);
        //console.log("No valido!");
    }
    //console.log(validaCampos);

    //console.log(this.state);
    this.setState({loadingvalue:false});   
  }
 
/*async  onClickProcesoFinal(){
    let idConducto='';
    if(!this.state.selectConducto){
        const datosJSON = {
            empresa: "AIGMETROPOLITANA",
            plataforma: "WEB",
            numeroCuentaOTarjeta: this.state.textCuenta,
            codigoBanco: this.state.selectBanco.value,
            tipoCuentaoTarjeta: this.state.selectTipo,
            tipoCuentaoTarjetaCodigoCore: this.state.codCoreTipo,
            tipoCuentaoTarjetaNombre: this.state.nombreTipo,
            idCliente: this.props.dataUsuario.cliCodigoCore,
            anioVencimientoTarjeta: this.state.textFecha,
            numeroCuotasMaximo: this.state.numCuotasF,
            valorCuotaMinima: this.state.valorCuotaMinimaF
        }
        //console.log("ENVIARRRR DATOS ", JSON.stringify(datosJSON))
        await this.props.guardarConducto(datosJSON);
        if (!this.props.datosGuardarConducto.guardarConductoHasError) {
            idConducto = this.props.datosGuardarConducto.idConducto;
            //console.log(idConducto);
            //window.location.reload(); 
        }
    }
    const PagoJSON = {
        empresa: "AIGMETROPOLITANA",
        plataforma: "WEB",
        idCarrito: this.props.datosPago.datosPagar.referencia,
        formCodigo: "debito-automatico",
        idConducto: idConducto,
        idPlanPago: this.state.selectPlan.value
    }
    console.log(PagoJSON);

  }
*/
  valValorCuota = (bandera) => {
    this.setState({
        hasValorCuotaError:bandera
    });
  }
  valNumCuota = (bandera) => {
    this.setState({
        hasNumCuotaError:bandera
    });
  }
  onIngresarConducto=(e)=>{
    e.preventDefault();
    this.setState({
        crearConducto: true,
    })   
  }

  onSelectConducto= async (id,e)=>{
    e.preventDefault();
    let dataConducto= undefined    
    if(this.state.datosListadoConductos.listaConductos.length>0 && this.state.datosListadoConductos.listaConductos !== undefined)
    {
         dataConducto = this.state.datosListadoConductos.listaConductos.find(conducto => conducto.id === id);
    }
    else{
         dataConducto = this.props.datosListadoConductos.listaConductos.find(conducto => conducto.id === id);
    }
    console.log('dc',dataConducto);
    if(dataConducto)
    {
        //Cargar la informacion de conducto        
        await this.cargarPlanesPorBanco(dataConducto.bancoId);

        this.setState({
            crearConducto: true,
            selectConducto: true,
            datosConductoSel : dataConducto,
            textCuenta: dataConducto.numeroCuenta,
            mostrarPlanesPago:true
        })   
        if(dataConducto.tipoCodigo==='3'){
            this.setState({
                esTarjeta: true
            })   
    
        }                
    }
    
  }
  onCancelarConducto=(e)=>{
    e.preventDefault();
    this.setState({
        crearConducto: false,
        selectConducto: false,
        esTarjeta:false,
        selectBanco: '',
        selectTipo: '',
        selectPlan: '',
        textCuenta:'',
        valCuotaCal:'0.00',
        hasBancoError: true,
        hasPlanError: true,
        valSubmit: false
    })   
  }

  onCancelarDebito=(e)=>{
    e.preventDefault();
    const param = new URLSearchParams(this.props.location.search);    
    let id = param.get('id');
    this.props.history.push({
        pathname: '/forma-pago',    
        search:`?id=${id}`
      });  
  }

  handleChangeBanco = async (selectBanco) => {
    this.setState({ selectBanco : selectBanco, mostrarPlanesPago:false});
    this.setState({hasBancoError:false});    

    //Setear en blnaco el plan
    this.setState({ selectPlan : '',
        valCuotaCal :'0.00'
    });
    this.setState({hasPlanError:true}); 

    await this.cargarPlanesPorBanco(selectBanco.value);
  }


cargarPlanesPorBanco= async (idbanco)=>{

    let resp = await FetchPost({
        url: urlGetPlanesPago, param: {
          empresa:"AIGMETROPOLITANA",
          ramo:this.props.dataFacturacion.datosFacturacion.carDescripcionRamo,
          bancosId : idbanco,  
          idCarrito: this.props.dataFacturacion.datosFacturacion.idCarrito     
        }
      })
      const { transaccion } = resp
      if (transaccion) {
        //Codigo cuando la transaccion es correcta          
        let planesPago = resp.planesPago;
        let arrayplanesPago = [];
        if (planesPago.length > 0)
          planesPago.forEach(elementP => {
            const elementoP = {
              value: elementP.id,
              label: elementP.nombre,
              cuotas: elementP.numeroCuotas
            }
            arrayplanesPago.push(elementoP)
          });                 
          //Obtener Planes Data debito actual          
          let DataDebitoActual=this.props.datosDebito.debitoAuomatico               
          if(DataDebitoActual)
          {
            DataDebitoActual = { ...DataDebitoActual, planesPago: arrayplanesPago };            
            await this.props.setDataDebitoPlanes(DataDebitoActual)
            this.setState({ mostrarPlanesPago:true});
          }
          else{
            alert('No se ha podido obtener información de los planes de pago.')
          }        
      }
      else{
        alert('No se ha podido obtener información de los planes de pago.')
      }
      
}

  valSubmit = () => {
    this.setState({valSubmit:true});
  }


  handleChangePlanPago= (selectPlan) => {
    let valorTotal = this.props.dataFacturacion.datosFacturacion.carValoresTotales.primaTotal;//this.props.datosCarrito.productosCarrito.valorTotal.totalcarrito;
    let cuotaPlan = selectPlan.cuotas;
    let calculo =  0;
    
    if(cuotaPlan !== null && cuotaPlan !== "" && cuotaPlan !== undefined && cuotaPlan !== 0 &&
    valorTotal !== null && valorTotal !== "" && valorTotal !== undefined && valorTotal !== 0){
        calculo = (Number(valorTotal)/Number(cuotaPlan)).toFixed(2); 
    }
    this.setState({ selectPlan : selectPlan,
        valCuotaCal :calculo
    });
    this.setState({hasPlanError:false});   
    //console.log(`Option selected plan:`, selectPlan);
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }
  

  render() {
    let { datosListadoConductos } = this.props;
    const { loadingvalue} = this.state;
    let { validate, esTarjeta, crearConducto,selectConducto,hasValorCuotaError,hasNumCuotaError,hasBancoError, hasPlanError, selectPlan, selectBanco,activePage,mostrarPlanesPago} = this.state;
    let numCuotaMax=0;
    let valCuotaMin=0;
        if(esTarjeta){
            numCuotaMax = this.state.selectBanco.mesesC;
            valCuotaMin = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaTarjeta;
        }else{
            numCuotaMax = this.state.selectBanco.mesesT;
            valCuotaMin = this.props.datosDebito.debitoAuomatico.valorCuotaMinimaCuenta;
        }
    //console.log(hasValorCuotaError,hasNumCuotaError,'asfasfas');
    //console.log(this.props.datosDebito.debitoAuomatico.bancos);    
    return (

    <LoadingScreen
        loading={this.props.datosGuardarConducto.guardarConductoIsLoading || datosListadoConductos.obtenerConductosIsLoading || this.props.datosGuardarFormaPago.guardarFormaPagoIsLoading || loadingvalue}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Cargando..."
      >
          <Page>
            <Row className="justify-content-md-center">
                <Col lg={8} md={8} sm={8} xs={12}>
                    <Card >
                    <CardHeader><h2 style={{ color: "#001871", textAlign: "center" }}> DÉBITO AUTOMÁTICO </h2></CardHeader>
                    <CardBody>
                        <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <h3 style={{ color: "#001871" }}> Detalle de Pago</h3>                        
                            <h5 style={{ textAlign: "left"}}> El Valor Total a Pagar es: <strong>$ {this.props.dataFacturacion.datosFacturacion.carValoresTotales.primaTotal}</strong>.</h5>
                        </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <Button className="btn btn-detail-white" onClick={this.onCancelarDebito}>
                            <i className="fa fa-arrow-circle-left" aria-hidden="true"></i>{" REGRESAR A FORMAS DE PAGO "}
                            </Button>
                            </Col>
                        </Row> 
                    </CardBody>
                    </Card>
                </Col>
            </Row>
            {crearConducto === false &&
            <Row className="justify-content-md-center">
                <Col lg={8} md={8} sm={8} xs={12}>
                    <Card >
                    <CardHeader><h3 style={{ color: "#001871", textAlign: "center" }}> Listado de Conductos </h3></CardHeader>
                    <CardBody>
                        <Row>
                            <div className="div-align-rigth">
                            <Button className="btn btn-purple" onClick={this.onIngresarConducto}>
                                <i className="fa fa-plus-circle" aria-hidden="true" />{" CREAR CONDUCTO "}
                            </Button>
                            </div>
                        </Row>   
                        <br></br>                      
                        {datosListadoConductos.listaConductos.length > 0 &&
                        <div>
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} >
                                <Table responsive className="table-bordered" style={{textAlign:"center"}}>
                                    <thead>
                                    <tr>
                                        <th style={{border: "1px solid #dee2e6"}}>#</th>
                                        <th style={{border: "1px solid #dee2e6"}}>Banco Emisor</th>
                                        <th style={{border: "1px solid #dee2e6"}}>Número de cuenta/tarjeta</th>
                                        <th style={{border: "1px solid #dee2e6"}}>Tipo</th>
                                        <th style={{border: "1px solid #dee2e6"}}>Pagar</th>
                                    </tr>
                                    </thead>
                                    {datosListadoConductos.listaConductos.map((conducto,index) => {
                                        const fin=activePage*5
                                        const inicio=fin-5
                                        return (
                                            <tbody>
                                                {index >= inicio && index< fin &&
                                                <tr>
                                                <td style={{border: "1px solid #dee2e6"}}>{index+1}</td>
                                                <td style={{border: "1px solid #dee2e6"}}>{conducto.bancoNombre}</td>
                                                <td style={{border: "1px solid #dee2e6"}}>{conducto.numeroCuenta}</td>
                                                <td style={{border: "1px solid #dee2e6"}}>{conducto.tipoNombre}</td>
                                                <td style={{border: "1px solid #dee2e6"}}>
                                                    <Button
                                                        className={"btn btn-primary"}
                                                        onClick={(e) => this.onSelectConducto(conducto.id,e)}  
                                                        style={{ display: "block", margin: "auto" }}
                                                    ><i className="fa fa-chevron-circle-right" aria-hidden="true" />{" SELECCIONAR"}
                                                    </Button>
                                                </td>
                                                </tr>
                                                }
                                            </tbody>
                                        );
                                    })}                
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                            <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={5}
                                totalItemsCount={this.state.numeroElementos}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                                linkClass={"paginaciontaga"}
                                activeLinkClass={"activepagination"}
                                innerClass={"pagination centrarpagination"}
                            />
                        </Col>
                        </Row>
                        </div>
                        }
                        {datosListadoConductos.listaConductos.length === 0 && 
                            <CardText><h5 style={{ textAlign: "center"}}> NO SE HA ENCONTRADO CONDUCTOS REGISTRADOS.</h5></CardText>
                        }                                
                    </CardBody>
                    </Card>
                </Col>
            </Row>
            }
            {crearConducto === true &&
            <form onSubmit={this.validateForm}>
            <Row className="justify-content-md-center">
                <Col lg={8} md={8} sm={8} xs={12}>
                <Card className="flex-row">
                    <CardBody>
                    <Row>
                        <Col lg={8} md={8} sm={8} xs={12}>
                            <h4 style={{ fontWeight: 'bold' }}>Datos del Pago</h4>
                            <p />
                        </Col>
                        <Col lg={4} md={4} sm={4} xs={12}>
                            <div>(*) Campos Requeridos</div>
                        </Col>               
                    </Row>
                    <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Entidad Financiera Emisora (*)</h5>
                        </Col>
                        {!selectConducto ? (
                        <Col lg={8} md={8} sm={8} xs={12}>
                            <Select
                                value={selectBanco}
                                //components={makeAnimated()}
                                onChange={this.handleChangeBanco}
                                options={this.props.datosDebito.debitoAuomatico.bancos}
                                isSearchable ={true}
                                placeholder ={"Seleccione una entidad financiera."}
                                isMulti ={false}
                            />
                            {hasBancoError && this.state.valSubmit &&
                                <span style={{color:"red",fontSize:"0.9rem"}}>Por favor seleccione la entidad financiera.</span>
                            }                
                        </Col>
                        ) : (
                        <Col lg={8} md={8} sm={8} xs={12}>  
                            <Textbox
                                tabIndex="1"
                                type="text"
                                id="txtBanco"
                                name="txtBanco"
                                classNameInput={"input-type-label form-control"}
                                value={this.state.datosConductoSel.bancoNombre}
                            />  
                        </Col>
                        )}   
                    </Row>
                    <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Tipo (*)</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                        {!selectConducto ? (
                            <Select1
                                tabIndex="6" // Optional.[String or Number].Default: none.
                                id={"selectTipo"} // Optional.[String].Default: "". Input ID.
                                name={"selectTipo"} // Optional.[String].Default: "". Input name.
                                value={this.state.selectTipo} // Optional.[String].Default: "".
                                optionList={this.props.datosDebito.debitoAuomatico.tiposConductos} // Required.[Array of Object(s)].Default: [].
                                validate={validate}
                                onBlur={e => {
                                //console.log(e);
                                }}
                                validationCallback={res =>
                                    this.setState({
                                      hasTipoError: res,
                                      validate: false
                                    })
                                }
                                onChange={(id, e) => {
                                    if (id === "3") 
                                        esTarjeta= true;
                                    else
                                        esTarjeta= false;
                                    var dataTipo =this.props.datosDebito.debitoAuomatico.tiposConductos.find(tipo => tipo.id === id);
                                    this.setState({
                                        esTarjeta,
                                        selectTipo: id,
                                        codCoreTipo: dataTipo.codigoCore,
                                        nombreTipo:dataTipo.name
                                    })                                 
                                }} // Optional.[Func].Default: () => {}. Will return the value.
                                customStyleOptionListContainer={{
                                    maxHeight: "200px",
                                    overflow: "auto",
                                    fontSize: "14px"
                                }}
                                validationOption={{
                                    name: "selectTipo", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                    check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                    required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                    msgOnError: "Por favor seleccione el tipo de conducto"
                                }}
                            />
                        ) : (
                            <Textbox
                                tabIndex="1"
                                type="text"
                                id="txtTipo"
                                name="txtTipo"
                                classNameInput={"input-type-label form-control"}
                                value={this.state.datosConductoSel.tipoNombre}
                            />  
                        )}   
                        </Col>
                    </Row>
                    {mostrarPlanesPago && 
                    
                    <div>

                        <Row>
                                <Col lg={4} md={4} sm={4} xs={12}>
                                    <h5>Plan de pago (*)</h5>
                                </Col>
                                <Col lg={8} md={8} sm={8} xs={12}>
                                    <Select
                                        value={selectPlan}
                                        //components={makeAnimated()}
                                        onChange={this.handleChangePlanPago}
                                        options={this.props.datosDebito.debitoAuomatico.planesPago}
                                        isSearchable ={true}
                                        placeholder ={"Seleccione un plan de pago."}
                                        isMulti ={false}
                                    />
                                    {hasPlanError && this.state.valSubmit &&
                                        <span style={{color:"red",fontSize:"0.9rem"}}>Por favor seleccione el plan de pago.</span>
                                    }        
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={4} md={4} sm={4} xs={12}>
                                <h5>{!esTarjeta ? "Número de cuenta (*)" : "Número de tarjeta (*)"}</h5>
                                {/*<h5>Número de cuenta o tarjeta(*)</h5>*/} 
                                </Col>
                                <Col lg={8} md={8} sm={8} xs={12}>
                                    <Textbox
                                        tabIndex="1"
                                        type="number"
                                        id="txtCuentaTarjeta"
                                        name="txtCuentaTarjeta"
                                        placeholder="1234 56789 0123 4567"
                                        classNameInput={
                                            !selectConducto
                                                ? "form-control"
                                                : "input-type-label form-control"
                                        }
                                        value={this.state.textCuenta}
                                        ref={this.textInput}
                                        maxLength = {12}
                                        validate={validate}
                                        onBlur={e => {
                                        //console.log(e);
                                        }}
                                        onChange={(textCuenta)=>this.setState({textCuenta})}
                                        validationCallback={res =>
                                            this.setState({
                                                hasCuentaError: res,
                                                validate: false
                                        })
                                        }
                                        validationOption={{
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            reg: /^[0-9]{6,12}$/,
                                            msgOnError: "Por favor ingrese un número de cuenta"
                                        }}
                                    />                            
                                </Col>
                            </Row>


                    </div>
                    
                    
                    
                    }
                    
                    
                  {esTarjeta === true && selectConducto === false &&
                    <div>
                    <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                            <Row className="justify-content-md-center">
                                <Col lg={6} md={6} sm={6} xs={12}>
                                        <h6>Fecha de expiración (*)</h6>
                                    <Textbox
                                        tabIndex="1"
                                        type="text"
                                        id="txtFechaVencimiento"
                                        name="txtFechaVencimiento"
                                        placeholder="MM/YY"
                                        classNameInput={
                                            !selectConducto
                                              ? "form-control"
                                              : "input-type-label form-control"
                                        }
                                        value={this.state.textFecha}
                                        ref={this.textInput}
                                        maxLength = {5}
                                        validate={validate}
                                        onBlur={e => {
                                        //console.log(e);
                                        }}
                                        onChange={(textFecha)=>this.setState({textFecha})}
                                        validationCallback={res =>
                                            this.setState({
                                              hasFechaError: res,
                                              validate: false
                                        })
                                        }
                                        validationOption={{
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            reg: /^([0-1][0-9]|[1-9])(\/)([1-9][0-9])$/,
                                            msgOnError: "La fecha de expiración es de la forma MM/YY y debe estar vigente"
                                        }}    
                                    />
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={12}>
                                    {/*<h6>Código de seguridad (*)</h6>
                                    <Textbox
                                        tabIndex="1"
                                        type="password"
                                        id="txtCodigoSeguridad"
                                        name="txtCodigoSeguridad"
                                        placeholder="CVV"
                                        classNameInput={"form-control"}
                                        value={this.state.textCodigo}
                                        ref={this.textInput}
                                        validate={validate}
                                        maxLength = {4}
                                        onBlur={e => {
                                            console.log(e);
                                        }}
                                        onChange={(textCodigo)=>this.setState({textCodigo})}
                                        validationCallback={res =>
                                            this.setState({
                                                hasCodigoError: res,
                                                validate: false
                                            })
                                        }
                                        validationOption={{
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                            reg: /^\d{4}|^\d{3}$/,
                                            msgOnError: "Por favor ingrese el codigo de seguridad correctamente"
                                        }}
                                    />*/}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </div>}
                    <Row>
                        <Col lg={4} md={4} sm={4} xs={12}>
                            <h5>Valor cuota</h5>
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={12}>
                            <Textbox
                                tabIndex="1"
                                type="text"
                                id="txtValorCuota"
                                name="txtValorCuota"
                                classNameInput={"input-type-label form-control"}
                                value={'$ '+this.state.valCuotaCal}
                            />       
                        </Col>
                    </Row>                  
                    <Row className="justify-content-md-center">
                        <Col lg={10} md={10} sm={10} xs={12}>
                            {hasNumCuotaError && this.state && (
                                <Alert color="warning">
                                    <center>
                                    <p>
                                    Para su entidad financiera solo se puede diferir hasta<strong> {numCuotaMax} </strong>meses.
                                    </p>
                                    </center>
                                </Alert>
                            )}                    
                            {hasValorCuotaError  && (
                                <Alert color="warning">
                                    <center>
                                    <p>
                                        El valor de las cuotas no puede ser menor a <strong>$ {valCuotaMin} </strong>.
                                    </p>
                                    </center>
                                </Alert>
                            )}                     
                        </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                        <div>
                            <Button
                                className={"btn btn-primary"}
                                onClick={this.validateForm}
                            ><i className="fa fa-chevron-circle-right" aria-hidden="true" /> 
                            {!selectConducto ? " GUARDAR" :" PAGAR"}
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                                className={"btn btn-detail-white"}
                                type="submit"
                                onClick={this.onCancelarConducto}
                            ><i className="fa fa-ban" aria-hidden="true" /> CANCELAR  
                            </Button>
                        </div>
                    </Row>
                </CardBody>
                </Card>
                </Col>
            </Row>
            </form>
            }
      </Page>


      </LoadingScreen>

    );
  }
}

const mapStateToProps = state => ({
    datosPago:state.datosPago,
    datosCarrito:state.dataProductoCarrito,
    datosDebito:state.datosDebitoAutomatico,
    dataUsuario:state.datosUsuarios.dataUsuario,
    datosListadoConductos:state.datosListadoConductos,
    datosGuardarConducto:state.datosGuardarConducto,
    datosGuardarFormaPago:state.datosGuardarFormaPago,
    //Obtener datos de un servicio comun
    dataFacturacion : state.dataFacturacion
});

const mapDispatchToProps = dispatch => {
    return {
        guardarConducto: datos => dispatch(FetchGuardarDatosConducto(datos)),
        guardarFormaPago: datos => dispatch(FetchGuardarFormaPago(datos)),
        listarConductos: datos => dispatch(FetchObtenerConductos(datos)),
        setDataDebitoPlanes: (datos) => dispatch(setObtenerDatosDebitoAutomatico(datos))
    };
  };
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DebitoAutomatico)
);
